import { useState } from "react"
import { Integration, RateTableConfig } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import { useFetchRateTableConfigsQuery } from "../../../../../redux/queries"
import Form from "../../../form"

interface Props {
  integration: Integration
}

const RateTableSelector = ({ integration }: Props) => {
  const { app_settings, saveAppSetting } =
    useIntegrationSettingsForm(integration)

  const [selectedID, setSelectedRateTableID] = useState<string>(
    String(
      app_settings?.rate_table_config ??
        (app_settings?.settings as Record<string, unknown>)
          ?.rate_table_config ??
        ""
    )
  )

  const { data: rateTables = [], isLoading } = useFetchRateTableConfigsQuery(
    { brand_id: integration?.brand_id },
    { skip: !integration?.brand_id }
  )

  const setSelected = (rateTableID: string) => {
    if (rateTableID !== selectedID) {
      setSelectedRateTableID(rateTableID)
      saveAppSetting({ rate_table_config: rateTableID })
    }
  }

  return (
    <Form.Select
      label="Choose a rate table"
      showLabel={false}
      size="sm"
      isLoading={isLoading}
      data={rateTables as RateTableConfig[]}
      setSelected={setSelected}
      selected={selectedID || undefined}
    />
  )
}

export default RateTableSelector
